export class LocalLogout {
  private running = false;

  execute(closeMenu: () => Promise<any>, clearLocations: () => void,
    clearService: () => void, clearRoot: () => void, setRoot: () => Promise<any>): void {
    if (this.running) {
      return;
    }
    this.running = true;

    const clearAndNavigate = () => {
      clearLocations();
      clearService();
      clearRoot();
      return setRoot();
    };
    const release = () => {
      this.running = false;
    };

    Promise.resolve().then(closeMenu).then(clearAndNavigate, clearAndNavigate).then(release, release);
  }
}



// WEBPACK FOOTER //
// ./src/utils/local-logout.ts